import { Accordion, Toast } from 'react-bootstrap';
import { Ai2Layout } from '../../layout/Ai2Layout';
import { CreateTeamForm } from '../../components/teams/CreateTeamForm';
import React, { useState } from 'react';
import './style.css';
import { useSelector } from 'react-redux';
import { TeamListing } from '../../components/teams/TeamListing';
import { useForm } from 'react-hook-form';
import { useGetTeams } from '../../components/teams/hooks/useGetTeams';
import { useEffect } from 'react';
import { useGetHospitalAllClinicians } from '../../components/teams/hooks';
import { useToastMessage } from '../../hooks/useToastMessage';
import { SystemPermission } from '../../../context';
import type { RootState } from '../../../store';
import { useAllRoles } from '../../../context/RoleContext';
import { isEmpty } from 'lodash';

export const TeamTabs = Object.freeze({
  CREATE_TEAM: 'create-team',
});

const TeamInfoPage = () => {
  const { postGetTeams, teams, isLoading: isLoadingTeams } = useGetTeams();
  const {
    postGetHospitalAllClinicians,
    cliniciansByHospital,
    isLoading: isLoadingAllClinicians,
  } = useGetHospitalAllClinicians();
  const { closeToast, showToast, setToast, toastMessage } = useToastMessage();
  const [activeTab, setActiveTab] = useState('');
  const [count, setCount] = useState(0);
  const { tenancyRoles, permissionKeyValuePair, fetchAllRoles } = useAllRoles();

  useEffect(() => {
    if (isEmpty(tenancyRoles) && isEmpty(permissionKeyValuePair)) {
      fetchAllRoles();
    }
  }, [tenancyRoles, permissionKeyValuePair]);

  const { clinics, selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const filteredClinics = clinics.filter(
    (clinic: any) => clinic.organisation_unit === 'hospital',
  );

  const teamFilterForm = useForm({
    defaultValues: {
      selected_clinics_ids:
        filteredClinics.length > 0 ? [filteredClinics[0].clinic_id] : [],
    },
  });

  const selectedHospitalIds = teamFilterForm.watch('selected_clinics_ids');

  const reloadTeams = () => setCount((cur) => cur + 1);

  const canEditTeam =
    !selectedTenancy?.permissionsSetup ||
    (selectedTenancy?.permissionsSetup &&
      selectedTenancy?.userPermissions &&
      !!(selectedTenancy?.userPermissions)[SystemPermission.ASSIGN_TEAM]);

  const canCreateTeam =
    !selectedTenancy?.permissionsSetup ||
    (selectedTenancy?.permissionsSetup &&
      selectedTenancy?.userPermissions &&
      !!(selectedTenancy?.userPermissions)[SystemPermission.MANAGE_TEAM]);

  useEffect(() => {
    postGetTeams(selectedHospitalIds);
    postGetHospitalAllClinicians(selectedHospitalIds);
  }, [count, selectedHospitalIds]);

  const isLoading = React.useMemo(
    () => isLoadingTeams || isLoadingAllClinicians,
    [isLoadingTeams, isLoadingAllClinicians],
  );

  return (
    <Ai2Layout>
      <div className="ui team-info-page">
        <div className="flexVert offsetNavbar height-100-percent">
          <TeamListing
            clinics={clinics}
            teamFilterForm={teamFilterForm}
            teams={teams}
            isLoading={isLoading}
            cliniciansByHospital={cliniciansByHospital}
            reloadTeams={reloadTeams}
            setToast={setToast}
            canEditTeam={canEditTeam}
          />
          {!isLoading && canCreateTeam ? (
            <Accordion
              activeKey={activeTab}
              onSelect={(key) => setActiveTab(key as string)}
              className="team-content-padding"
            >
              <Accordion.Item eventKey={TeamTabs.CREATE_TEAM}>
                <Accordion.Header>
                  <span className="create-new-team-heading">
                    Create new team
                  </span>
                  {activeTab !== TeamTabs.CREATE_TEAM ? (
                    <i className="fa fa-plus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-minus" aria-hidden="true" />
                  )}
                </Accordion.Header>
                <Accordion.Body className="create-team-form-container">
                  <CreateTeamForm
                    selectedHospitalIds={selectedHospitalIds}
                    clinics={clinics}
                    setToast={setToast}
                    reloadTeams={reloadTeams}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ) : null}
        </div>
      </div>
      <Toast show={showToast} onClose={closeToast} className="team-toast">
        <Toast.Header>{/* <small>11 mins ago</small> */}</Toast.Header>
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
    </Ai2Layout>
  );
};

export { TeamInfoPage };
